/* CANFOTO R7.48 — presentation-only, no scoring/cache writes, draft-only rollout */
(() => {
  'use strict';
  const handles = new Set([
    'gdx-ed300w-bi-color-bowens-mount-cob-led-studyo-isigi',
    'gdx-ml-200c-ii-200w-tasinabilir-bi-color-cob-led-video-isigi',
    'gdx-ed-300c-ii-video-ve-fotograf-surekli-tekli-isik-seti',
    'gdx-exc-800c-ii-video-ve-fotograf-tekli-surekli-isik-set',
    'gdx-hue-300r-tekli-dolgu-isigi-rgb-cob-led-seti'
  ]);
  const match = location.pathname.match(/^\/products\/([^/?]+)/);
  if (!match || !handles.has(decodeURIComponent(match[1]))) return;
  const labels = Object.freeze({
    baby_family_soft_key:'Bebek ve aile / yumuşak ana ışık',
    large_softbox_key:'Geniş softbox / ana ışık',
    procedure_technical_closeup:'Teknik işlem / yakın plan',
    technical_product_document_archive:'Teknik ürün / belgeleme',
    food_culinary:'Yemek / mutfak çekimi',
    clinical_aesthetic_before_after:'Klinik estetik / önce-sonra',
    makeup_beauty:'Makyaj / güzellik',
    podcast_audio_sensitive:'Podcast / sessiz ortam',
    single_person_interview:'Tek kişilik röportaj',
    catalog_white_background_key:'Beyaz fon / katalog ana ışığı',
    dental_closeup_documentation:'Dental / yakın plan belgeleme',
    hair_salon_content:'Kuaför / salon içeriği'
  });
  const keys = Object.keys(labels);
  const exact = new RegExp('^(' + keys.join('|') + ')$', 'i');
  const mixed = new RegExp('\\b(' + keys.join('|') + ')\\b', 'gi');
  let busy=false;
  function refresh(){
    if(busy) return;
    busy=true;
    try {
      const headings=[...document.querySelectorAll('h1,h2,h3,h4')].filter(e=>/5 (?:NORA |dinamik )?setup önerisi/i.test(e.textContent||''));
      for(const head of headings){
        let root=head.parentElement;
        for(let i=0;i<4 && root && root.querySelectorAll('*').length<12;i++)root=root.parentElement;
        if(!root)continue;
        const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
        const nodes=[];
        while(walker.nextNode()){
          const node=walker.currentNode;
          if(!node.parentElement||node.parentElement.closest('script,style,textarea,input,option,[contenteditable="true"]'))continue;
          if(!mixed.test(node.nodeValue||'')){mixed.lastIndex=0;continue;}mixed.lastIndex=0;
          nodes.push(node);
        }
        for(const node of nodes){
          const current=node.nodeValue;
          const next=current.replace(mixed,(key)=>labels[key.toLowerCase()]||key);
          mixed.lastIndex=0;
          if(next!==current)node.nodeValue=next;
        }
      }
    }finally{busy=false;}
  }
  let scheduled=false;
  const observer=new MutationObserver(()=>{
    if(scheduled)return;scheduled=true;
    requestAnimationFrame(()=>{scheduled=false;refresh();});
  });
  const init=()=>{refresh();observer.observe(document.body,{childList:true,subtree:true,characterData:true});};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  window.__CANFOTO_R748_LABEL_QA=()=>({handle:match[1],version:'R748_LABELS_V1',mappingCount:keys.length,scope:'5 COB PDPs',scoreWrites:0,cacheWrites:0,setupWrites:0});
})();
